import TemplateView from '../../../../TemplateView'

export default class EmptyList extends TemplateView {
    constructor({
        actionOnEmptyList = () => {},
    }) {
        super()

        this.params = {
            actionOnEmptyList,
        }

        this.state = {
            openTabKey: "",
            isAssignMoreSubtitle: false,
            isNoSelectedTitle: false,
            titlesMap: {},
            noSelectedTitlesMap: {},
            subtitlesAssignItemsMap: {},
            subtitlesAssignMoreItemsMap: {},
            withBorderAndBackground: true,
            noWorkScopeWarningText: "",
        }

        this.onAnyStatePropertyChanged(
            [
                'openTabKey',
                'isAssignMoreSubtitle',
                'isNoSelectedTitle',
                'titlesMap',
                'noSelectedTitlesMap',
                'subtitlesAssignItemsMap',
                'subtitlesAssignMoreItemsMap',
                'noWorkScopeWarningText',
            ], ({
                openTabKey,
                isAssignMoreSubtitle,
                isNoSelectedTitle,
                titlesMap,
                noSelectedTitlesMap,
                subtitlesAssignItemsMap,
                subtitlesAssignMoreItemsMap,
                noWorkScopeWarningText,
            }) => {
                const titleText = isNoSelectedTitle ? noSelectedTitlesMap[openTabKey] : titlesMap[openTabKey]
                this.$emptyListTitle.text(titleText)
                this.$emptyListTitle.toggle(!noWorkScopeWarningText)
                this.$noWorkScopeWarning.toggle(!!noWorkScopeWarningText)

                noWorkScopeWarningText && this.$noWorkScopeWarningText.text(noWorkScopeWarningText)

                let subtitleText = ""
                if (isAssignMoreSubtitle) {
                    subtitleText = subtitlesAssignMoreItemsMap[openTabKey]
                } else {
                    subtitleText = subtitlesAssignItemsMap[openTabKey]
                }
                this.$emptyListSubTitle.text(subtitleText)
            }
        )

        this.onStatePropertyChanged('withBorderAndBackground', withBorderAndBackground => {
            this.getEl().toggleClass('withBorderAndBackground', withBorderAndBackground)
        })
    }

    templateHtml() {
        return "<div class='emptyCptList'>" +
               "    <div class='noWorkScopeWarning'>" +
               "        <span class='warningIcon'/>" +
               "        <span class='warningText'/>" +
               "    </div>" +
               "    <div class='title'></div>" +
               "    <div class='subTitle'></div>" +
               "</div>"
    }

    afterRender() {
        this.$emptyListTitle = this.find(".title")
        this.$emptyListSubTitle = this.find(".subTitle")
        this.$noWorkScopeWarning = this.find(".noWorkScopeWarning")
        this.$noWorkScopeWarning.hide()
        this.$noWorkScopeWarningText = this.$noWorkScopeWarning.find('.warningText')

        this.$emptyListSubTitle.click((e) => {
            this.params.actionOnEmptyList()
            e.stopPropagation()
        })

        this.renderInitialState()
    }
}


// WEBPACK FOOTER //
// ./web/js/administration/userManagement/hierarchyAssignmentsPanelTab/components/EmptyList.js